var React = require('react');

function ChevronDown (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"points":"386.258,91.567 203.718,273.512 21.179,91.567 0,112.815 203.718,315.87 407.437,112.815 "}));
}

ChevronDown.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 407.437 407.437","style":{"enableBackground":"new 0 0 407.437 407.437"},"xmlSpace":"preserve"};

module.exports = ChevronDown;

ChevronDown.default = ChevronDown;
